module.exports = __webpack_public_path__ + "img/paozhe.28ae4473.png";